import { render, staticRenderFns } from "./jzsContractDetail.vue?vue&type=template&id=5ae7770c&scoped=true&"
import script from "./jzsContractDetail.vue?vue&type=script&lang=js&"
export * from "./jzsContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./jzsContractDetail.vue?vue&type=style&index=0&id=5ae7770c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae7770c",
  null
  
)

export default component.exports